import React, { useMemo } from 'react';
import moment from 'moment/moment';

import { LineChart } from '../../../charts';

import {
  prepareCasesDataDaily,
  prepareCasesDataMonthly,
  prepareCasesDataQuarterly,
} from '../../../../utils/analytics';

import { presets } from '../../../../constants/analytics';

const CountsSubmittedLineChart = ({ counts = [], compareCounts = [], tenantColor, minDate, maxDate, preset, minDateCompare, maxDateCompare, presetCompare }) => {
  const getChartData = (filteredCounts, min, max) => {
    if (min.month() === max.month() && min.year() === max.year()) {
      const daysInMonth = preset === presets.LAST_MONTH ? moment().subtract(1, 'month').daysInMonth() : moment().daysInMonth();
      const numberOfDays = filteredCounts[0]?.date ? moment(filteredCounts[0]?.date).daysInMonth() : daysInMonth;
      return prepareCasesDataDaily(filteredCounts, numberOfDays);
    }

    if (min.quarter() === max.quarter() && min.year() === max.year()) {
      const quarter = preset === presets.LAST_QUARTER ? moment().subtract(1, 'quarter').quarter() : moment().quarter();
      const initialQuarter = filteredCounts[0]?.date ? quarter : moment(filteredCounts[0]?.date).quarter();
      return prepareCasesDataQuarterly(filteredCounts, initialQuarter);
    }

    return prepareCasesDataMonthly(filteredCounts);
  };

  const chartData = useMemo(() => {
    const data = getChartData(counts, minDate, maxDate);

    if (presetCompare) {
      const comparedCounts = compareCounts.filter((item) => minDateCompare.isBefore(item.date) && maxDateCompare.isAfter(item.date));
      const compareData = getChartData(comparedCounts, minDateCompare, maxDateCompare);

      if (preset === presets.THIS_QUARTER && presetCompare === presets.PREVIOUS_PERIOD) {
        const previousQuarter = compareData?.map((item) => ({
          data: item.data?.map((i, index) => ({ x: data[0]?.data[index]?.x, y: i.y })),
          id: `${item.id}_compare`
        }));
        return [...previousQuarter, ...data];
      }

      return [...compareData?.map((item) => ({ ...item, id: `${item.id}_compare` })), ...data];
    }

    return data;
  }, [counts, compareCounts, minDate, maxDate, minDateCompare, maxDateCompare, presetCompare]);

  return (
    <div className="management-reports-chart__container m-r-md" style={{ width: '50%' }}>
      <div className="font-size-bg font-bold">Total Stock Counts</div>
      <div className="secondary m-t-sm m-b-lg">Total counts submitted in period</div>
      <LineChart
        height='300px'
        data={chartData}
        colors={chartData.length > 1 ? ['var(--app-text-subtle)', tenantColor] : tenantColor}
        margin={{ top: 20, right: 15, bottom: 30, left: 30 }}
        entity='count'
      />
    </div>
  );
};

export default CountsSubmittedLineChart;
